import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { getHomeSchema } from './components/HomeSchema';

export default function Home() {
  const seoTitle = '草榴二维码 - 最新入口获取与使用指南';
  const seoDesc = '草榴二维码是进入草榴社区的重要通道，本页提供最新草榴二维码获取方式、扫码步骤详解、安全使用建议及常见问题解答，帮助用户快速找到可用的草榴二维码入口，避免因链接失效而无法访问的困扰。';
  const seoKeywords = '草榴二维码,草榴二维码最新,草榴社区二维码,草榴入口二维码,草榴二维码扫码,草榴二维码失效解决,草榴最新地址二维码';

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalUrl="/"
        schemaData={getHomeSchema()}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}